import React from 'react'
import { connect } from 'react-redux'
import { clearHeader, clearSkip } from 'actions/general'
import ReCAPTCHA from 'react-google-recaptcha'
import { getRecaptchaKey } from 'util/recaptcha'
import ResetPasswordForm from './form'
import { postPasswordReset } from 'actions/password'
import { autoLoginRedirect } from 'util/redirect'
import withRouter from 'hocs/with-router'

function mapStateToProps(state) {
  return {
    result: state.password.getIn(['setReturnData', 'result'], null),
    loading: state.password.get('loading', false),
    submitError: state.password.get('error', false),
    redirectUrl: state.general.get('portalUrl', null),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    clearHeader: payload => dispatch(clearHeader(payload)),
    clearSkip: payload => dispatch(clearSkip(payload)),
    postPasswordReset: payload => dispatch(postPasswordReset(payload)),
  }
}

class ResetPassword extends React.PureComponent {
  componentDidUpdate(prevProps, prevState) {
    if (
      !this.props.submitError &&
      this.props.result === 'success' &&
      this.props.redirectUrl &&
      !this.state.recaptchaPending
    ) {
      autoLoginRedirect(this.props.navigate, this.props.redirectUrl)
    }
  }

  componentDidMount() {
    this.props.clearHeader()
    this.props.clearSkip()
  }

  _submit = values => {
    if (this.recaptcha.getValue()) {
      this.recaptcha.reset()
    }
    return new Promise((resolve, reject) => {
      this.setState(
        {
          values: { ...values },
          recaptchaPending: true,
        },
        () => {
          this.resolve = resolve
          this.reject = reject
          if (sessionStorage.getItem('disableRecaptcha') === 'true') {
            this._recaptchaChange('disabledForTesting')
          } else {
            this.recaptcha.execute()
          }
        }
      )
    }).then(() => {
      this.setState({ recaptchaPending: false })
    })
  }

  _recaptchaChange = value => {
    const token = sessionStorage.getItem('token')
    const values = this.state.values
    values.captchaToken = value
    this.props.postPasswordReset({
      values,
      resolve: this.resolve,
      reject: this.reject,
      token,
    })
  }

  render() {
    return (
      <div className='user'>
        <h1 className='heading--main'>Reset Password</h1>
        <ResetPasswordForm
          onSubmit={this._submit}
          loading={this.props.loading}
        />
        <ReCAPTCHA
          ref={recaptcha => {
            this.recaptcha = recaptcha
          }}
          size='invisible'
          sitekey={getRecaptchaKey()}
          onChange={this._recaptchaChange}
        />
      </div>
    )
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ResetPassword)
)
